import axios from 'axios';
import { toast } from 'react-toastify';
import config from '../config';

const DOMAIN = config.REACT_APP_SERVER_DOMAIN;

/**
 * Déconnexion centralisée — utilisée par Sidebar et Topbar
 */
export const handleLogout = async (navigate) => {
  try {
    await axios.post(`${DOMAIN}/users/logout`);
    localStorage.removeItem('persist:root');
    toast.success('Déconnexion réussie !');
    navigate('/login');
    window.location.reload();
  } catch (error) {
    // Même en cas d'erreur API, on force la déconnexion côté client
    localStorage.removeItem('persist:root');
    toast.info('Session terminée.');
    navigate('/login');
    window.location.reload();
  }
};
